import React, { useContext } from "react";
import ErrorBoundary from '../../Utils/ErrorBoundary'
import DeviceScan from "./DeviceScan/DeviceScan";
import Summary from "./Summary/Summary";
import { useParams } from "react-router-dom";
import DeleteIcon from '@material-ui/icons/Delete';
import UnregisterDeviceDialog from "./UnregisterDeviceDialog/UnregisterDeviceDialog";
import { useState } from "react";
import AuthContext from "../../../context/auth-context";
import moment from "moment";
import { dataFetchReducer } from "../../Utils/requestUtils";
import { useReducer, useEffect } from "react";
import axios from "axios";
import CircularProgress from '@material-ui/core/CircularProgress';

function DeviceManagerDevice() {
    const { device_key } = useParams();

    const user_data = useContext(AuthContext).user_data

    const [updatePage, setUpdatePage] = useState(false);

    const [openUnregistedDeviceDialog, setOpenUnregistedDeviceDialog] = useState(false);

    const handleUpdatePage = () => {
        setUpdatePage(true)
        setOpenUnregistedDeviceDialog(false)
    }

    const [device, dispatchDevice] = useReducer(
		dataFetchReducer,
		{ fetchedData: null, isLoading: true, isError: false }
	)

	useEffect(() => {
		dispatchDevice({ type: "data_fetch_init" })
		const timer = setTimeout(() => {
			axios.get('/dash/device_manager/device/' + device_key).then(response => {
				dispatchDevice({
					type: "data_fetch_success",
					payload: response.data
				})
			}).catch(error => {
				if ((error.response || {}).status === 403) dispatchDevice({ type: "data_fetch_failure_403" })
				else if ((error.response || {}).status === 404) dispatchDevice({ type: "data_fetch_failure_404" })
				else dispatchDevice({ type: "data_fetch_failure" })
			})
		}, 500);
		return () => {
			clearTimeout(timer)
		}
	}, [device_key, updatePage])

    if (device.fetchedData) {
        return (
            <div style={{ minWidth: "900px", overflow: "auto", paddingBottom: "30px" }}>
                <div className="analysisCardContainer" style={{ display: "flex" }}>
                    <ErrorBoundary>
                        <div>
                            <div className={["blueText", "titleSize"].join(" ")} style={{margin:"5px 0px"}}>
                                Análise de Dispositivo
                            </div>
                            <div className={["labelText", "subtitleSize"].join(" ")} style={{margin:"5px 0px", display: 'flex', flexDirection: "column"}}>
                                {"Dispositivo #" + device.fetchedData.external_id + "  analisado em " + moment(device.fetchedData.created_at).format("DD/MM/YYYY") +
                                " às " + moment(device.fetchedData.created_at).format("HH:mm")}
                            </div>
                        </div>

                        {(user_data.roles.includes("manage_device_manager") && 
                        (device.fetchedData.status !== "not_registered" && device.fetchedData.status !== "deactivated")) && 
                        <div
                            className={["listCardItem", "whiteText", "redBackground", "subtitleSize", "breakWord", "bold"].join(" ")}
                            style={{
                                width: "fit-content",
                                textAlign: "center",
                                cursor: "pointer",
                                borderRadius: "7px",
                                padding: "8px 16px",
                                minWidth: "180px",
                                marginLeft: "auto",
                                alignSelf: "flex-start"
                            }}
                            onClick={() => setOpenUnregistedDeviceDialog(true)}
                        >
                            <DeleteIcon />
                            Desativar Dispositivo
                        </div>}
                    </ErrorBoundary>
                </div>
                <div className="analysisCardContainer" style={{ display: "flex" }}>
                    <ErrorBoundary>
                        <div>
                            <div className={["blueText", "subtitleSize"].join(" ")} style={{ margin: "25px 0px" , marginBottom: "10px" }}>
                                {"Conta: " + device.fetchedData.account_id}
                            </div>
                        </div>
                    </ErrorBoundary>
                </div>
                <div className="analysisCardContainer" style={{ display: "flex" }}>
                    <ErrorBoundary>
                        <div>
                            <div className={["blueText", "subtitleSize"].join(" ")} style={{ margin: "5px 0px" , marginBottom: "30px" }}>
                                {"Titular: " + device.fetchedData.person_id}
                            </div>
                        </div>
                    </ErrorBoundary>
                </div>

                <div style={{ display: "grid", gridTemplateColumns:"33.3% 66.7%" }}>
                    <div style={{flexGrow: "1", flexDirection: "column"}} className="analysisCardContainer">
                        <ErrorBoundary>
                            <Summary deviceData={device.fetchedData}/>
                        </ErrorBoundary>
                    </div>

                    
                    <div style={{flexGrow: "1", flexDirection: "column"}} className="analysisCardContainer">
                        <ErrorBoundary>
                            <DeviceScan deviceScanData={device.fetchedData.device_scan_data}/>
                        </ErrorBoundary>
                    </div>
                </div>

                <UnregisterDeviceDialog
                    open={openUnregistedDeviceDialog}
                    user_data={user_data} 
                    setOpenUnregistedDeviceDialog={setOpenUnregistedDeviceDialog}
                    handleUpdatePage={handleUpdatePage}
                    device={device.fetchedData}     
                />
            </div>
        );
    }
    else if (device.isLoading) {
		return (
			<div style={{ width: "auto" }}>
				<div className='circularProgressCenter'>
					<CircularProgress />
				</div>
			</div>
		)
	}
	else if (device.isError) {
		return (
			<div style={{ height: "80vh", display: "flex" }}>
				<p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
					{device.errorMessage}
				</p>
			</div>
		)
	}
    else {
        return (
            <div style={{ height: "80vh", display: "flex" }}>
                <p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
                    Device not found
                </p>
            </div>
        );
    }
}

export default DeviceManagerDevice;
